!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/icons/Icon")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/icons/Icon"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/icons/Icon")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (r, n) {
  return u = {}, o.m = i = {
    0: function (e, t) {
      e.exports = r;
    },
    1: function (e, t) {
      e.exports = n;
    },
    661: function (e, t, r) {
      "use strict";

      r.r(t), r.d(t, "default", function () {
        return o;
      });
      var t = r(0),
        n = r.n(t),
        t = r(1),
        r = r.n(t),
        t = function (e) {
          var t = e.color,
            e = e.fillRule;
          return n.a.createElement("path", {
            fill: t,
            fillRule: e,
            d: "M13.07 13.07V8.68h-2.14v4.39zm0 4.34v-2.19h-2.14v2.19zM0 20.68L12 0l12 20.68z"
          });
        };
      t.svg = {
        viewBox: "0 0 24 21"
      };
      var o = r()(t);
    }
  }, o.c = u, o.d = function (e, t, r) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var n in t) o.d(r, n, function (e) {
      return t[e];
    }.bind(null, n));
    return r;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 661);
  function o(e) {
    if (u[e]) return u[e].exports;
    var t = u[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return i[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var i, u;
});